import { useMutation } from '@tanstack/react-query'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { acceptConvertTransfer, putAcceptQuote } from 'services/WalletsService'
import { AcceptQuote } from 'types/payments'
import { ConvertTransferResponse } from 'types/wallets'

export interface AcceptQuoteVariables {
  quoteId: string
  digest: string
}

export const usePutAcceptQuoteMutation = () => {
  const { enableV3Convert } = useFeatureFlags()

  return useMutation({
    mutationFn: ({
      quoteId,
      digest,
    }: AcceptQuoteVariables): Promise<AcceptQuote | ConvertTransferResponse> =>
      enableV3Convert
        ? acceptConvertTransfer({ transferId: quoteId, digest })
        : putAcceptQuote(quoteId),
  })
}
